import { render, staticRenderFns } from "./specificGyList.vue?vue&type=template&id=f9aaab8e"
import script from "./specificGyList.vue?vue&type=script&lang=js"
export * from "./specificGyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports